import BaseComponent from 'foundation/base-component';
import React from 'react';
import ReactDOM from 'react-dom';
import WSCBlazeStoriesLayout from './wsc-blaze-stories-layout.js';

class WSCBlazeStoriesComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        ReactDOM.render(
            <WSCBlazeStoriesLayout options={this.options} />,
            this.element
        );
    }
}

export default WSCBlazeStoriesComponent;
